import React from 'react';
import Nav from '../components/Nav';
import { motion } from 'framer-motion';
import Footer from '../components/Footer';
const transition = { duration: 0.9, ease: [0.6, 0.01, -0.05, 0.9] };
const transitionMini = { duration: 0.9, ease: 'anticipate' };
const socialParent = {
  animate: {
    transition: {
      delayChildren: 0.4,
      staggerChildren: 0.04,
      staggerDirection: 1
    }
  }
}
const socialChild = {
  initial: {
    y: 50,
    opacity: 0
  },
  animate: {
    y: 0,
    opacity: 1,
    transition: {
      duration: 0.5,
      ...transitionMini
    },


  }
}

function Contact() {
  return (
    <motion.div
      initial={{ opacity: 0, }}
      animate={{ opacity: 1, }}
      exit={{ opacity: 0 }}
      transition={transition}>
      <Nav />
      <motion.section
        id="contact" className="page">
        <h3 className="main-heading">Let's Talk</h3>

        <motion.div
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: 0, ...transition }}
          className="email">
          <a href="mailto:hello@sashen.me">hello@sashen.me</a>
        </motion.div>
        <motion.ul initial='initial'
          animate='animate'
          exit='exit'
          variants={socialParent} className="social-links">
          <motion.li
            key={1}
            variants={socialChild}
          >
            <a href="tel:+94777331452" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="30" height="31.405" viewBox="0 0 30 31.405">
                <path id="phone" d="M30,24.8a7.686,7.686,0,0,1-.213,1.573,9.157,9.157,0,0,1-.447,1.527,5.816,5.816,0,0,1-2.6,2.364A7.978,7.978,0,0,1,22.776,31.4a8.128,8.128,0,0,1-1.129-.078,8.306,8.306,0,0,1-1.225-.279q-.671-.2-1-.324t-1.182-.457q-.852-.335-1.044-.4a18.92,18.92,0,0,1-3.728-1.851A32.462,32.462,0,0,1,7.841,23.2a33.374,33.374,0,0,1-4.6-5.888,20.659,20.659,0,0,1-1.768-3.9q-.064-.2-.383-1.093T.65,11.074q-.117-.345-.309-1.049A9.62,9.62,0,0,1,.074,8.744,9.1,9.1,0,0,1,0,7.562,8.964,8.964,0,0,1,1.087,3.413,5.9,5.9,0,0,1,3.345.692,8.211,8.211,0,0,1,4.8.223,6.729,6.729,0,0,1,6.306,0a1.141,1.141,0,0,1,.447.067Q7.137.2,7.883,1.762q.234.424.639,1.2t.746,1.417q.341.636.661,1.193.064.089.372.557a6.417,6.417,0,0,1,.458.792,1.5,1.5,0,0,1,.149.636A1.877,1.877,0,0,1,10.3,8.677,10.579,10.579,0,0,1,8.981,9.9,13.036,13.036,0,0,0,7.66,11.086a1.717,1.717,0,0,0-.607,1.026,1.564,1.564,0,0,0,.107.5q.107.3.181.457t.3.536q.224.379.245.424a23.367,23.367,0,0,0,3.707,5.242A22.463,22.463,0,0,0,16.6,23.153q.042.023.4.256t.512.312a4.365,4.365,0,0,0,.437.189,1.409,1.409,0,0,0,.479.112q.383,0,.98-.636A13.316,13.316,0,0,0,20.539,22a10.753,10.753,0,0,1,1.172-1.383,1.747,1.747,0,0,1,1.065-.636,1.341,1.341,0,0,1,.607.156,5.887,5.887,0,0,1,.757.48q.447.324.532.39.532.335,1.14.692t1.353.781q.746.424,1.151.669,1.492.781,1.619,1.182A1.3,1.3,0,0,1,30,24.8Z" />
              </svg>
            </a>
          </motion.li>
          <motion.li
            key={2}
            variants={socialChild}
          >
            <a href="https://wa.me/+94777331452" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="31.255" height="31.405" viewBox="0 0 31.255 31.405">
                <path id="whatsapp" d="M22.874,18.819c-.389-.195-2.3-1.134-2.656-1.265s-.616-.194-.877.2-1,1.264-1.23,1.523-.454.292-.843.1a10.681,10.681,0,0,1-3.127-1.931,11.655,11.655,0,0,1-2.163-2.695c-.226-.389-.024-.6.17-.793.175-.174.39-.454.584-.68a2.691,2.691,0,0,0,.39-.651.71.71,0,0,0-.033-.68c-.1-.195-.876-2.109-1.2-2.887-.317-.757-.637-.654-.876-.667s-.5-.014-.746-.013a1.425,1.425,0,0,0-1.036.487A4.362,4.362,0,0,0,7.871,12.1a7.568,7.568,0,0,0,1.588,4.022C9.653,16.386,12.2,20.314,16.1,22a21.963,21.963,0,0,0,2.217.818,5.3,5.3,0,0,0,2.448.154,4.01,4.01,0,0,0,2.625-1.849,3.227,3.227,0,0,0,.226-1.849c-.1-.162-.356-.259-.746-.454m-7.094,9.687h-.005a12.916,12.916,0,0,1-6.583-1.8l-.471-.28-4.9,1.285,1.306-4.773-.307-.489a12.935,12.935,0,1,1,10.957,6.061M26.786,4.565A15.565,15.565,0,0,0,2.294,23.341L.086,31.4l8.25-2.164a15.548,15.548,0,0,0,7.436,1.895h.006A15.569,15.569,0,0,0,26.787,4.563Z" transform="translate(-0.086 0)" fill="#1a1b1d" />
              </svg>
            </a>
          </motion.li>
          <motion.li
            key={3}
            variants={socialChild}
          >
            <a href="https://messenger.com/sashenme" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="31.087" height="31.405" viewBox="0 0 31.087 31.405">
                <path id="messanger" d="M20.181,22.491l-4.02-4.177L8.417,22.6l8.488-9.007,4.02,4.177,7.741-4.281L20.18,22.491ZM18.543,3C9.959,3,3,9.507,3,17.536A14.17,14.17,0,0,0,8.775,28.841V34.4l5.3-2.943a16.543,16.543,0,0,0,4.463.609c8.586,0,15.545-6.508,15.545-14.536S27.128,3,18.543,3Z" transform="translate(-3 -2.999)" fill="#1a1b1d" fill-rule="evenodd" />
              </svg>

            </a>
          </motion.li>
          <motion.li
            key={5}
            variants={socialChild}
          >
            <a href="https://github.com/sashenme" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="32.191" height="31.405" viewBox="0 0 32.191 31.405">
                <path id="github" d="M16.1,0a15.746,15.746,0,0,1,8.079,2.159,16.021,16.021,0,0,1,5.858,5.858A15.746,15.746,0,0,1,32.191,16.1a15.643,15.643,0,0,1-3.071,9.462,15.769,15.769,0,0,1-7.932,5.816.94.94,0,0,1-.839-.147.819.819,0,0,1-.273-.629q0-.063.011-1.6t.011-2.819a3.733,3.733,0,0,0-1.09-2.976,14.391,14.391,0,0,0,2.148-.377,8.556,8.556,0,0,0,1.97-.817,5.849,5.849,0,0,0,1.7-1.394,6.5,6.5,0,0,0,1.111-2.2,10.571,10.571,0,0,0,.431-3.154,6.208,6.208,0,0,0-1.656-4.317,5.58,5.58,0,0,0-.168-4.275,2.743,2.743,0,0,0-1.7.231,11.322,11.322,0,0,0-1.928.922l-.8.5a15.139,15.139,0,0,0-8.048,0q-.335-.231-.891-.566a12.606,12.606,0,0,0-1.749-.807A2.883,2.883,0,0,0,7.65,6.664a5.58,5.58,0,0,0-.168,4.275,6.208,6.208,0,0,0-1.656,4.317A10.475,10.475,0,0,0,6.255,18.4a6.714,6.714,0,0,0,1.1,2.2,5.68,5.68,0,0,0,1.687,1.4,8.513,8.513,0,0,0,1.97.817,14.446,14.446,0,0,0,2.148.377,3.539,3.539,0,0,0-1.027,2.159,4.188,4.188,0,0,1-.943.315,5.859,5.859,0,0,1-1.195.1,2.478,2.478,0,0,1-1.373-.451,3.684,3.684,0,0,1-1.163-1.31,3.378,3.378,0,0,0-1.017-1.09,3.069,3.069,0,0,0-1.037-.5l-.419-.063a1.368,1.368,0,0,0-.608.094q-.168.094-.1.241a1.155,1.155,0,0,0,.189.293,1.542,1.542,0,0,0,.273.251l.147.1a2.524,2.524,0,0,1,.912.8,5.255,5.255,0,0,1,.66,1.069l.209.482a2.656,2.656,0,0,0,.922,1.289,3.268,3.268,0,0,0,1.4.629,8.864,8.864,0,0,0,1.457.147,6.244,6.244,0,0,0,1.163-.073l.482-.084q0,.8.011,1.855t.011,1.142a.819.819,0,0,1-.273.629.94.94,0,0,1-.839.147A15.764,15.764,0,0,1,3.07,25.555,15.642,15.642,0,0,1,0,16.1,15.746,15.746,0,0,1,2.159,8.017,16.021,16.021,0,0,1,8.017,2.159,15.746,15.746,0,0,1,16.1,0ZM6.1,23.117q.063-.147-.147-.251-.209-.063-.273.042-.063.147.147.251Q6.014,23.285,6.1,23.117Zm.65.713q.147-.1-.042-.335-.209-.189-.335-.063-.147.1.042.335Q6.622,23.976,6.749,23.83Zm.629.943q.189-.147,0-.4-.168-.273-.356-.126-.189.1,0,.377T7.377,24.773Zm.88.88q.168-.168-.084-.4-.251-.251-.419-.063-.189.168.084.4Q8.089,25.841,8.257,25.653Zm1.195.524q.063-.231-.273-.335-.315-.084-.4.147t.273.315q.315.126.4-.126Zm1.321.1q0-.273-.356-.231-.335,0-.335.231,0,.273.356.231Q10.772,26.512,10.772,26.281Zm1.215-.209q-.042-.231-.377-.189-.335.063-.293.315t.377.168q.335-.084.293-.293Z" fill="#1a1b1d" />
              </svg>

            </a>
          </motion.li>
          <motion.li
            key={4}
            variants={socialChild}
          >
            <a href="https://twitter.com/sashenme" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="35" height="28.426" viewBox="0 0 35 28.426">
                <path id="twitter" d="M35.269,3.376a15.011,15.011,0,0,1-3.6,3.708q.022.311.022.933a20.38,20.38,0,0,1-.844,5.763A20.83,20.83,0,0,1,28.285,19.3a21.688,21.688,0,0,1-4.1,4.675,18.232,18.232,0,0,1-5.73,3.242,21,21,0,0,1-7.174,1.21A19.92,19.92,0,0,1,.269,25.206,15.345,15.345,0,0,0,2,25.295a14.04,14.04,0,0,0,8.9-3.065A7.184,7.184,0,0,1,4.2,17.255a9.123,9.123,0,0,0,1.355.111,7.433,7.433,0,0,0,1.887-.244,7.054,7.054,0,0,1-4.12-2.476,6.926,6.926,0,0,1-1.632-4.563V9.993a7.112,7.112,0,0,0,3.242.91A7.162,7.162,0,0,1,2.6,8.35a7,7,0,0,1-.867-3.42,7.025,7.025,0,0,1,.977-3.619,20.316,20.316,0,0,0,6.54,5.3A20,20,0,0,0,17.5,8.816a7.968,7.968,0,0,1-.178-1.643,6.912,6.912,0,0,1,2.1-5.074,7.19,7.19,0,0,1,10.315.167A14.039,14.039,0,0,0,34.291.533a6.969,6.969,0,0,1-3.153,3.953,14.3,14.3,0,0,0,4.131-1.11Z" transform="translate(-0.269)" fill="#1a1b1d" />
              </svg>


            </a>
          </motion.li>
          <motion.li
            key={7}
            variants={socialChild}
          >
            <a href="https://linkedin.com/in/sashenpasindu" target="_blanks">
              <svg xmlns="http://www.w3.org/2000/svg" width="32.86" height="31.405" viewBox="0 0 32.86 31.405">
                <path id="linkedin" d="M7.466,10.673v21.2H.406v-21.2H7.466Zm.449-6.546a3.387,3.387,0,0,1-1.081,2.61,4.034,4.034,0,0,1-2.9,1.049H3.894A3.862,3.862,0,0,1,1.07,6.737,3.5,3.5,0,0,1,0,4.127,3.446,3.446,0,0,1,1.1,1.507,4.025,4.025,0,0,1,3.979.469,3.912,3.912,0,0,1,6.824,1.507,3.57,3.57,0,0,1,7.916,4.127Zm24.944,15.6V31.874H25.821V20.535a6.187,6.187,0,0,0-.866-3.519,3.045,3.045,0,0,0-2.706-1.273,3.464,3.464,0,0,0-2.257.738,4.552,4.552,0,0,0-1.358,1.829,5.167,5.167,0,0,0-.235,1.732v11.83H11.359q.043-8.536.043-13.841T11.381,11.7l-.021-1.027H18.4v3.081h-.043a9.364,9.364,0,0,1,.877-1.2,9.082,9.082,0,0,1,1.209-1.113,5.569,5.569,0,0,1,1.861-.931,8.422,8.422,0,0,1,2.449-.33,7.6,7.6,0,0,1,5.883,2.428q2.224,2.428,2.225,7.114Z" transform="translate(0 -0.469)" fill="#1a1b1d" />
              </svg>
            </a>
          </motion.li>
        </motion.ul>
      </motion.section>
      <Footer />
    </motion.div>
  )
}

export default Contact
